import React from 'react';

import './style.module.scss';

const TabTable = ({ data }) => {
  const groupedData = {};

  data?.fields?.forEach(field => {
    if (!groupedData[field.rowId]) {
      groupedData[field.rowId] = [];
    }

    groupedData[field.rowId].push(field);
  });

  return (
    <table>
      <thead>
        <tr>
          {data?.columns
            ?.sort((a, b) => a.id - b.id)
            .map(column => (
              <th key={`header-${column.id}`}>{column.column}</th>
            ))}
        </tr>
      </thead>
      <tbody>
        {Object.keys(groupedData)
          .sort((a, b) => a.id - b.id)
          .map(rowId => (
            <tr key={`row-${rowId}`}>
              {data?.columns
                ?.sort((a, b) => a.id - b.id)
                .map(column => {
                  const field = groupedData[rowId].find(
                    f => f.columnId === column.id,
                  );
                  return (
                    <td key={`cell-${rowId}-${column.id}`}>
                      {field?.value
                        .split('\\n')
                        .sort((a, b) => a.id - b.id)
                        .map(line => (
                          <div key={`line-${line}`}>{line}</div>
                        ))}
                    </td>
                  );
                })}
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default TabTable;
